/**
 * Pure MSAL env resolution for the console (no `window`, no `import.meta`), copied
 * from the product SPA's msalEnv so the same helpers stay testable in isolation.
 *
 * The console app registration is single-tenant corporate, so the authority is always
 * the Microsoft login endpoint for the console tenant. There is no External ID
 * (ciamlogin) case here: a customer-tenant authority would issue a token the console
 * API refuses as a wrong audience (spec.md 8C row NR-2).
 */
export function resolveConsoleAuthorityFromEnv(
  env: Record<string, string | undefined>,
): string {
  const explicit = (env.VITE_CONSOLE_ENTRA_AUTHORITY || "").trim();
  if (explicit) {
    return explicit;
  }
  const tenant = (env.VITE_CONSOLE_ENTRA_TENANT_ID || "").trim();
  return tenant ? `https://login.microsoftonline.com/${tenant}` : "";
}

/**
 * The console redirect URI is always the origin the browser is already on, so one
 * build serves every slot and DEV without an environment-specific value in code
 * (ASDM section 10). The app registration lists those origins; this returns the one
 * in use.
 */
export function resolveConsoleRedirectUri(origin: string): string {
  return (origin || "").replace(/\/$/, "");
}
